export function coordinate(value, limit = 180) {
  if ((typeof value !== "number" && typeof value !== "string") || String(value).trim() === "") return null;
  const number = Number(value);
  return Number.isFinite(number) && Math.abs(number) <= limit ? number : null;
}

export function mapPosition(latitude, longitude) {
  const lat = coordinate(latitude, 90), lng = coordinate(longitude, 180);
  return lat === null || lng === null ? null : { lat, lng };
}

export function fieldIsStale(user, now = Date.now()) {
  const recorded = Date.parse(user.location_recorded_at);
  return user.shift_state !== "active" || user.is_stale || !Number.isFinite(recorded) || now - recorded > 60000;
}

export function mergeFieldLocation(user, data) {
  const incoming = Date.parse(data.captured_at);
  const existing = Date.parse(user.location_captured_at);
  if (!mapPosition(data.latitude, data.longitude) || !Number.isFinite(incoming) || (Number.isFinite(existing) && incoming <= existing)) return user;
  return { ...user, latitude: data.latitude, longitude: data.longitude, accuracy_m: data.accuracy_m, location_captured_at: data.captured_at, location_recorded_at: data.recorded_at, shift_state: "active", is_stale: false };
}
